import styled from '@emotion/styled'
import { Link } from 'react-router-dom'

export const Wrapper = styled.div(
  ({ theme }) => `
    height: 72px;
    display: flex;
    align-items: center;
    cursor: pointer;
    box-sizing: border-box;

    :hover {
      background-color: rgba(0, 0, 0, 0.8);

      @media (max-width: 768px) {
        background-color: ${theme.ds.ColorBaseGreyLevel5};
      }
    }

    @media (max-width: 768px) {
      justify-content: space-between;
      height: 60px;
    }
  `
)

export const MenuButton = styled.button(
  ({ theme }) => `
  display: none;
  width: 80px;
  height: 100%;
  outline: none;
  background-color: ${theme.ds.ColorBaseGreyLevel5};
  cursor: pointer;

  @media (max-width: 768px) {
    display: block;
  }
`
)

export const MenuButtonIcon = styled.img`
  width: 40px;
  height: auto;
`

export const HomeLink = styled(Link)`
  display: flex;
  width: 100%;
  justify-content: center;
`
